<mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="onTabChange($event)" mat-stretch-tabs mat-align-tabs="center">
  <mat-tab i18n-label="@@products" label="Products">
    <div>
      <div class="header-style">
        <div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handleProductPage($event)"></mat-paginator>
          
          @if(productsList.length > 0) {
            <mat-menu #exportProductsMenu="matMenu">
              <button mat-menu-item i18n="@@exportAsCSV" (click)="exportDistributerProducts(1)">Export as CSV</button>
              <button mat-menu-item i18n="@@exportAsPDF" (click)="exportDistributerProducts(2)">Export as PDF</button>
              <button mat-menu-item i18n="@@exportAsExcel" (click)="exportDistributerProducts(3)">Export as Excel</button>
            </mat-menu>
            <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportProductsMenu"></mat-icon>
          }

          <form [formGroup]="searchForm" (ngSubmit)="doProductSearch()">
            @if (showSearchProduct) {
              <mat-form-field class="search-field">
                <mat-label i18n="@@searchLabel">Search</mat-label>
                <input i18n-placeholder="@@searchPlaceholder" data-testid="products_search_input" matInput formControlName="productSearch" id="productSearch" placeholder="Search" name="productSearch"/>
                <mat-icon data-testid="products_clear" class="cursor" matSuffix (click)="clearProductSearch()" i18n-aria-label aria-label="@@clear">clear</mat-icon>
              </mat-form-field>
            }
          </form>
          <mat-icon data-testid="products_search" (click)="handleProductSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="@@search"></mat-icon>
        </div>
      </div>
      @for (item of productsList; track item; let itemIndex = $index) {
        <mat-card (click)="openProduct(item.isSupeAdminHasAccess, item.id, item.name, item.isAddedByManufacturer)" [ngClass]="{'cursor': !item.isAddedByManufacturer}" class="{{(itemIndex % 2 === 0 ? 'lite-box mr-16' : 'lite-box m-0')}}">
          <mat-card-content class="d-flex">
            <img [src]="item.picture" (error)="onImgError($event)">
            <div class="content-box">
              <div class="text-wrapper">
                <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.name}}</div>
                <div class="mat-caption" matTooltip ellipsisTooltip>{{truncateDescription(item.description)}}</div>
              </div>
              @if (!item.isSupeAdminHasAccess) {
                <mat-icon class="cursor lock-icon" color="warn" i18n-aria-label aria-label="@@locked">lock</mat-icon>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }
      @if (productsList.length === 0) {
        <img class="empty-view-img" i18n-alt alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
      }
    </div>
  </mat-tab>

  <mat-tab i18n-label="@@subscriptions" label="Subscriptions">
    <div>
      <div class="header-style">
        <div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <mat-paginator i18n-aria-label="@@paginator" [length]="subTotalSize" [pageSize]="subPageSize" [pageIndex]="subPageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handleSubPage($event)"></mat-paginator>

          @if(subscribtionList.length > 0) {
            <mat-menu #exportSubscriptionsMenu="matMenu">
              <button mat-menu-item i18n="@@exportAsCSV" (click)="exportDistributerSubscriptions(1)">Export as CSV</button>
              <button mat-menu-item i18n="@@exportAsPDF" (click)="exportDistributerSubscriptions(2)">Export as PDF</button>
              <button mat-menu-item i18n="@@exportAsExcel" (click)="exportDistributerSubscriptions(3)">Export as Excel</button>
            </mat-menu>
            <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportSubscriptionsMenu"></mat-icon>
          }

          <form [formGroup]="searchForm" (ngSubmit)="doSubSearch()">
            @if (showSearchSub) {
              <mat-form-field class="search-field">
                <mat-label i18n="@@searchLabel">Search</mat-label>
                <input i18n-placeholder="@@searchPlaceholder" matInput formControlName="subSearch" id="subSearch" placeholder="Search" name="subSearch"/>
                <mat-icon class="cursor" matSuffix (click)="clearSubSearch()" i18n-aria-label aria-label="@@clear">clear</mat-icon>
              </mat-form-field>
            }
          </form>
          <mat-icon (click)="handleSubSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="@@search"></mat-icon>
        </div>
      </div>
      <div class="cards-container">
        @for (item of subscribtionList; track item; let itemIndex = $index) {
          <mat-card class="tall-box">
            <mat-card-content>
              <img style="height: 196px" class="cursor" [src]="item.picturePath" (error)="img.src = imageSrc" #img>
              <div class="content-box">
                <div class="flex-grow cursor">
                  <div class="mat-subtitle-1 margin-bottom" matTooltip ellipsisTooltip>{{truncateName(item.firstName, item.lastName)}}</div>
                  <div class="mat-caption" matTooltip ellipsisTooltip>{{item.email | slice:0:14}}{{item.email.length > 14 ? '...' : ''}}</div>
                </div>
                <mat-icon data-testid="delete_user_button" (click)="deleteUser(item.id)" color="warn" class="cursor" i18n-aria-label aria-label="@@delete">delete_outline</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
      @if (subscribtionList.length === 0) {
        <img class="empty-view-img" i18n-alt alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
      }
    </div>
  </mat-tab>

  <mat-tab i18n-label="@@promotions" label="Promotions">
    <div>
      <div class="header-style">
        <div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <mat-paginator i18n-aria-label="@@paginator" [length]="sponsorsTotalSize" [pageSize]="sponsorPageSize" [pageIndex]="sponsorPageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handleSponsorsPage($event)"></mat-paginator>
          <mat-icon data-testid="add_promotion_button" (click)="openAddPromotion()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-aria-label aria-label="@@add"></mat-icon>
          
          @if(promotionsList.length > 0) {
            <mat-menu #exportPromotionsMenu="matMenu">
              <button mat-menu-item i18n="@@exportAsCSV" (click)="exportDistributerPromotions(1)">Export as CSV</button>
              <button mat-menu-item i18n="@@exportAsPDF" (click)="exportDistributerPromotions(2)">Export as PDF</button>
              <button mat-menu-item i18n="@@exportAsExcel" (click)="exportDistributerPromotions(3)">Export as Excel</button>
            </mat-menu>
            <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportPromotionsMenu"></mat-icon>
          }

          <form [formGroup]="searchForm" (ngSubmit)="doSponsorSearch()">
            @if (showSearchSponsor) {
              <mat-form-field class="search-field">
                <mat-label i18n="@@searchLabel">Search</mat-label>
                <input i18n-placeholder="@@searchPlaceholder" data-testid="promotions_search_input" matInput formControlName="sponsorSearch" id="sponsorSearch" placeholder="Search" name="sponsorSearch"/>
                <mat-icon data-testid="promotions_clear_button" class="cursor" matSuffix (click)="clearSponsorSearch()" i18n-aria-label aria-label="@@clear">clear</mat-icon>
              </mat-form-field>
            }
          </form>
          <mat-icon data-testid="promotions_search_button" (click)="handleSponsorSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="@@search"></mat-icon>

        </div>
      </div>
      @for (item of promotionsList; track item; let itemIndex = $index) {
        <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
          <mat-card-content class="content-box">
            <div>
              <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip i18n="@@promotionCode">Code - {{item.code}}</div>
              @if (item.isUsed) {
                <div i18n="@@used" class="mat-caption mb-8">Used</div>
              }
              @if (!item.isUsed) {
                <div i18n="@@notUsed" class="mat-caption mb-8">Not Used</div>
              }
              <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.expireDate}}</div>
              <div class="mat-caption mb-8 d-inline" matTooltip ellipsisTooltip>
                @if (item.isUsed) {
                  <span i18n="@@companyUsed">Company Used: {{item.companyName}} </span>
                }
                @if (!item.isUsed) {
                  <span>.</span>
                }
              </div>
            </div>
            <mat-icon data-testid="promotions_delete_button" class="cursor" color="warn" (click)="deletePromotion(item.id, item.code)" aria-hidden="false" i18n-aria-label aria-label="@@delete">delete_outline</mat-icon>
          </mat-card-content>
        </mat-card>
      }
      @if (promotionsList.length === 0) {
        <img class="empty-view-img" i18n-alt alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
      }
    </div>
  </mat-tab>

</mat-tab-group>
